var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48824 4.80029C5.29298 4.60503 5.29298 4.28845 5.48824 4.09319L8.78853 0.792893C9.17906 0.40237 9.81222 0.402368 10.2027 0.792893L13.503 4.09319C13.6983 4.28845 13.6983 4.60503 13.503 4.80029C13.3078 4.99555 12.9912 4.99555 12.7959 4.80029L9.9917 1.99605V11.539C9.9917 11.8151 9.76784 12.039 9.4917 12.039C9.21555 12.039 8.9917 11.8151 8.9917 11.539V2.00394L6.19535 4.80029C6.00009 4.99555 5.6835 4.99555 5.48824 4.80029ZM1 6.99988C1 6.72374 0.776142 6.49988 0.5 6.49988C0.223858 6.49988 0 6.72374 0 6.99988V13.4999C0 14.8806 1.11929 15.9999 2.5 15.9999H16.5C17.8807 15.9999 19 14.8806 19 13.4999V6.99988C19 6.72374 18.7761 6.49988 18.5 6.49988C18.2239 6.49988 18 6.72374 18 6.99988V13.4999C18 14.3283 17.3284 14.9999 16.5 14.9999H2.5C1.67157 14.9999 1 14.3283 1 13.4999V6.99988Z",
    fill: "#2167AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/FileUpload.9f5cced5792c440ce4231d753f1f63c5.svg";
export { ForwardRef as ReactComponent };